module.exports = __webpack_public_path__ + "img/footer-org-icon.ddab9fab.svg";